import { FloatingFieldSize } from "./context";

export type SizeStyleValues = {
  inputHeight: string;
  fontSize: string;
  labelBaseTop: string;
  translateY: string;
  textInputPaddingTop: string;
  calendarPaddingTop: string;
  multiSelectPaddingLeft: string;
  multiSelectIndicatorPaddingTop: string;
  multiValueMinHeight: string;
  multiValueLabelPaddingOverride: string | undefined;
  paddingTop: string;
  timezoneValuePaddingTop: string;
  timezoneValuePaddingLeft: string;
  singleValuePaddingTop: string;
  singleValuePaddingLeft: string;
};

export const sizeStyles: Record<FloatingFieldSize, SizeStyleValues> = {
  md: {
    inputHeight: "3rem", // 48px
    fontSize: "1rem", // 16px — matches Chakra Input md
    labelBaseTop: "16px", // centered for 16px font in 48px: (48-16)/2 = 16px
    translateY: "-12px", // floated: 16-12 = 4px from top
    textInputPaddingTop: "18px",
    calendarPaddingTop: "25px",
    multiSelectPaddingLeft: "8px",
    multiSelectIndicatorPaddingTop: "10px",
    multiValueMinHeight: "24px",
    multiValueLabelPaddingOverride: undefined,
    paddingTop: "26px", // multi-select value container
    timezoneValuePaddingTop: "19px",
    timezoneValuePaddingLeft: "7px",
    singleValuePaddingTop: "21px",
    singleValuePaddingLeft: "6px",
  },
  sm: {
    inputHeight: "2.5rem", // 40px
    fontSize: "0.875rem", // 14px — matches Chakra Input sm
    labelBaseTop: "13px", // centered for 14px font in 40px: (40-14)/2 = 13px
    translateY: "-9px", // floated: 13-9 = 4px from top
    textInputPaddingTop: "17px",
    calendarPaddingTop: "21px",
    multiSelectPaddingLeft: "8px",
    multiSelectIndicatorPaddingTop: "8px",
    multiValueMinHeight: "20px",
    multiValueLabelPaddingOverride: "1px",
    paddingTop: "25px", // multi-select value container
    timezoneValuePaddingTop: "17px",
    timezoneValuePaddingLeft: "2px",
    singleValuePaddingTop: "18px",
    singleValuePaddingLeft: "6px",
  },
};
